<template>
  <div>
      <div v-if="pcFlag == 'YD'">
        <YD></YD>
        <!-- <PC></PC>         -->
      </div>
      <div v-if="pcFlag == 'PC'">
        <PC></PC>
        <!-- <YD></YD> -->
      </div>
  </div>
</template>
<script>
import { Toast , Notify  } from 'vant';
import PC from './indexPc.vue'
import YD from './indexYd.vue'
export default {
  name: 'index',
  data () {
    return {
      pcFlag:""
    }
  },
  components:{
    PC,
    YD
  },
  mounted(){
    if(!window.navigator) {  
      console.log('app')
    }else{
      if(/Mobile|Android|webOS|iPhone|iPad|Phone/i.test(navigator.userAgent)){
        console.log("移动")
        this.pcFlag = 'YD'
        // Notify({ type: 'warning', message: "移动" });
      }
      else{
        this.pcFlag = 'PC'
        // Notify({ type: 'warning', message: "PC" });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  background: tan;
  .all{
    width: 100px;
    height: 50px;
    background: red
  }
}
</style>




// WEBPACK FOOTER //
// src/components/index.vue